import { Stepper, styled } from '@mui/material';

const StyledStepper = styled(Stepper)({
  width: '200px',
});

export { StyledStepper };
